import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import addChatterLesson from "./addLesson.schema";
import { successMessageToast } from "helpers/common";
import { cloneDeep } from "lodash";
import { CHATTER_LESSON_LIST } from "config/paths";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { MIME_TYPES } from "config/constants";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useChatterLessonDetailsQuery, useCreateChatterLessonMutation, useGetChatterLessonTagsQuery, useUpdateChatterLessonMutation } from "store/services/chatter/lesson";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { RequiredFieldAstrick } from "components/Common/Common";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import LoadingButton from "components/shared/LoadingButton";

const ChatterLessonPlanAdd = () => {

  const { id: lessonId } = useParams();

  const editMode = !!lessonId;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({ title: "", description: "", tags: [], status: "active", files: [], });

  const { data: lessonDetails, isLoading } = lessonId ? useChatterLessonDetailsQuery(lessonId) : {};
  const [createLesson, { isLoading: createLessonLoading }] = useCreateChatterLessonMutation();
  const [updateLesson, { isLoading: updateLessonLoading }] = useUpdateChatterLessonMutation();
  const { data: lessonTags, isLoading: lessonTagsLoading } = useGetChatterLessonTagsQuery()

  const handleSubmit = async (payload) => {

    try {

      const values = cloneDeep(payload);
      const result = editMode ? await updateLesson({ data: values, lessonId }) : await createLesson(values);

      if (result?.error) {
        console.error("Error creating chatter lesson", result.error);
      } else {
        successMessageToast(result?.data?.message);
        navigate(CHATTER_LESSON_LIST);
      }
    } catch (err) {
      console.error("Error creating chatter lesson", err);
    }
  };

  const handleAttachDocument = (name, value, prevValues, setFieldValue) => {
    try {
      let cloneValues = cloneDeep(prevValues);
      cloneValues.push({
        attachment_key: value,
        attachment_name: value,
      })
      setFieldValue(name, cloneValues);
    } catch (err) {
      console.error("Failed to attach document", err);
    }
  };

  useEffect(() => {

    if (!lessonId) return;

    setInitialValues({
      title: lessonDetails?.title,
      description: lessonDetails?.description,
      tags: lessonDetails?.lessonTags?.length ? lessonDetails?.lessonTags?.map((item) => item?.tag_id) : [],
      files: lessonDetails?.files?.map(resource => ({
        id: resource.id,
        attachment_key: resource.attachment_key,
        attachment_name: resource.attachment_name
      })) || [],
      status: lessonDetails?.status,
    });

  }, [lessonDetails]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3 d-flex align-items-center">
                <Link
                  className="themeBlue fw-sbold back-to-btn"
                  to="/manage-chatter/lesson-plans/"
                >
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                  </svg> Back
                </Link>
                <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Chatter Lesson" : "Add Chatter Lesson"}</h6>
              </div>
            </Col>
            {
              isLoading ? <LoadingIndicator /> :
                <Col lg="12" className="my-2">
                  {/* <Formik
                    initialValues={initialValues}
                    validationSchema={addChatterLesson}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit,
                      values,
                      setFieldValue,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div
                          className="py-3"
                          style={{ borderTop: "1px solid #41a2a84d" }}
                        >
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Add Lesson Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="title"
                                placeholder="Add title"
                                className={`${styles.formControl} form-control`}
                                maxLength={30}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Add Description
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="description"
                                placeholder="Add description"
                                className={`${styles.formControl} form-control`}
                                maxLength={500}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Add Tag
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                type="text"
                                name="tag"
                                placeholder="Add Tag"
                                className={`${styles.formControl} form-control`}
                              />
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex"
                              >
                                Attach Documents
                                <RequiredFieldAstrick />
                              </label>
                              <AppFileUploadField
                                name="files"
                                acl={"private"}
                                accept="application/pdf"
                                allowedTypes={[MIME_TYPES.pdf]}
                                className={`${styles.formControl} form-control`}
                                onChange={(name, value) => {
                                  handleAttachDocument(name, value, values?.files, setFieldValue);
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            <div
                              className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                              style={{ borderTop: "1px solid #41a2a84d" }}
                            >
                              <Button
                                type="submit"
                                className="d-flex align-items-center justify-content-center commonBtn"
                                disabled={createLessonLoading || updateLessonLoading}
                              >
                                {createLessonLoading || updateLessonLoading ? <LoadingIndicator inline /> : "Save"}
                              </Button>
                              <Button
                                type="button"
                                className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                onClick={() => navigate(CHATTER_LESSON_LIST)}
                              >
                                Cancel
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik> */}
                  <Formik
                    initialValues={initialValues}
                    validationSchema={addChatterLesson}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit,
                      setFieldValue,
                      isSubmitting,
                      errors,
                      touched,
                      setFieldTouched,
                      values,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div className="reports-v2">
                          <div className=" d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                            {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE A TEMPLATES"}</h6> */}
                          </div>
                          {console.log('formik values and errors', values, errors)}
                          <Row >
                            <Col md="8" className="my-2 name-input-v2">
                              <label
                                htmlFor=""
                                className="discharge-screen-label mt-0"
                              >
                                Lesson Name
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                name="title"
                                className={`${styles.formControl} readonly-box h-auto`}
                                styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                                placeholder="Enter lesson name"
                              />
                            </Col>
                            <Col md="8" className="mt-2">
                              <label
                                htmlFor=""
                                className="discharge-screen-label mt-0"
                              >
                                Description
                                <RequiredFieldAstrick />
                              </label>
                              <div className="editor-paren-v2">
                                <CustomEditor style={{ borderRadius: 0 }} name={`description`} />
                              </div>
                              {/* <CKEditorField
                        items={[
                          'bold',
                          'italic',
                          'underline',
                          'alignment',
                          '|',
                          'bulletedList',
                          'numberedList',
                        ]}
                        value={values?.answers}
                        handleChange={(event, editor) => {
                          setFieldValue(`answers`, editor?.getData());
                        }}
                      /> */}
                            </Col>
                            <Col md="8" className="my-2">
                              <label className="discharge-screen-label mt-0 mb-0">
                                Tag
                                <RequiredFieldAstrick />
                              </label>

                              <div className="d-flex area-pills flex-wrap gap-2 mt-2 mb-2">
                                {lessonTags?.records?.map((tag) => (
                                  <button
                                    key={tag?.id}
                                    type="button"
                                    // variant={values.tags?.includes(tag?.value) ? "primary" : "outline-secondary"}
                                    className={values.tags?.includes(tag?.id) ? "select-liberary-btn proxima-regular" : "non-select-liberary-btn proxima-regular"}
                                    onClick={() => {
                                      setFieldTouched('tags')
                                      if (values.tags?.includes(tag?.id)) {
                                        setFieldValue(
                                          "tags",
                                          values.tags.filter((t) => t !== tag?.id)
                                        );
                                      } else {
                                        setFieldValue("tags", [...(values.tags || []), tag?.id]);
                                      }
                                    }}
                                  >
                                    {tag?.title}
                                  </button>
                                ))}
                              </div>
                              {(touched?.tags && errors?.tags) ? (
                                <div className="error">{errors?.tags}</div>
                              ) : null}
                            </Col>
                            <Col md="4" sm="6" className="my-2"></Col>
                            <Col md="4" sm="6" className="my-2">
                              <label className="discharge-screen-label mt-0 mb-0">
                                Attach Documents
                                <RequiredFieldAstrick />
                              </label>
                              <AppFileUploadField
                                name="files"
                                acl={"private"}
                                accept="application/pdf"
                                allowedTypes={[MIME_TYPES.pdf]}
                                className={`${styles.formControl} readonly-box h-auto`}
                                onChange={(name, value) => {
                                  handleAttachDocument(name, value, values?.files, setFieldValue);
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                        <div className="btnWrpper mt-2 text-end d-flex justify-content-end">
                          <LoadingButton
                            type="submit"
                            className="blue-discharge-screen-btn"
                            isLoading={isSubmitting}
                          >
                            Submit
                          </LoadingButton>

                          {/* <LoadingButton
                  type="button"
                  className="blue-discharge-screen-btn"
                  onClick={() => { addToReport(values); closePopup(); }}
                  isLoading={isSubmitting}
                >
                  Add to Report
                </LoadingButton> */}
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Col>
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatterLessonPlanAdd;
